import { ErpCountryValue } from './../../../../common/person/model/person-values';
import { Component } from '@angular/core';
import { WithDatasourceComponent } from './with-datasource.component';

@Component( {
    selector: 'erp-pbw-staatsangehoer',
    templateUrl: './with-datasource.component.html'
} )
export class NationalityFormComponent extends WithDatasourceComponent<ErpCountryValue>   {

    constructor() {
        super(
            {
                datasourceName: 'api/v1/rm/erp/person/value/erpCountry',
                fieldDisplayName: 'textNationality',
                i18nIdentifier: 'rm.erp.jobapplication.JobApplication.nationality',
            } );
    }

    set value( t: ErpCountryValue | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.nationality = t;
        }
    }

    get value(): ErpCountryValue | undefined {
        return this.jobapplication?.nationality;
    }

    getFieldValue( t?: ErpCountryValue ): string | undefined {
        return t?.textNationality;
    }
}
